/** Compact register number after blur: digits, optional 1–2 uppercase letters, no spaces. */
export const REGISTRATION_NUMBER_PATTERN = /^[1-9]\d*[A-Z]{0,2}$/

const MAX_REGISTRATION_NUMBER_INPUT = 40

interface RegisterParts {
  numberPart: string
  suffix: string
}

function suffixLetterCount(suffix: string): number {
  let count = 0
  for (const ch of suffix) {
    if (ch >= 'A' && ch <= 'Z') count += 1
  }
  return count
}

function takeRegisterChar(parts: RegisterParts, ch: string): RegisterParts {
  const inSuffix = suffixLetterCount(parts.suffix) > 0
  if (ch >= '0' && ch <= '9') {
    return inSuffix ? parts : { ...parts, numberPart: parts.numberPart + ch }
  }
  if (/\s/.test(ch)) {
    if (inSuffix) {
      if (parts.suffix.endsWith(' ')) return parts
      return { ...parts, suffix: parts.suffix + ' ' }
    }
    if (parts.numberPart.length === 0 || parts.numberPart.endsWith(' ')) return parts
    return { ...parts, numberPart: parts.numberPart + ' ' }
  }
  if (ch >= 'A' && ch <= 'Z' && suffixLetterCount(parts.suffix) < 2) {
    return { ...parts, suffix: parts.suffix + ch }
  }
  return parts
}

export function sanitizeRegistrationNumberInput(raw: string): string {
  const clipped = raw.length > MAX_REGISTRATION_NUMBER_INPUT ? raw.slice(0, MAX_REGISTRATION_NUMBER_INPUT) : raw
  const parts = [...clipped.toUpperCase()].reduce(takeRegisterChar, { numberPart: '', suffix: '' })
  return parts.numberPart + parts.suffix
}

export function normalizeRegistrationNumber(value: unknown): string | undefined {
  if (value == null || value === '') return undefined
  if (typeof value !== 'string' && typeof value !== 'number') return undefined
  const compact = String(value).replace(/\s+/g, '').toUpperCase()
  return compact === '' ? undefined : compact
}
